import React from "react";

const TituloSection = (props) => {
  const {
    producto,
    pasajerosAdultos,
    pasajerosMenores,
    totalPaqueteConPlanFamily,
  } = props;

  return (
    <div className="title">
      <h5>
        Paquete a {producto.detalleWeb} {producto.dias} dias - {producto.noches}{" "}
        noches para {pasajerosAdultos.length + pasajerosMenores.length}{" "}
        personas:
      </h5>
      {producto.destino.idDestino !== "LMG" && (
        <p>(Traslado + Hoteler&iacute;a + Pasajes)</p>
      )}
      {/* FC: descomentar cuando se cobre en pesos 
      {producto.moneda.codigoMoneda !== "PES" && (
        <p>
          {producto.tarifas[0].tarifaNeta} {producto.moneda.codigoMoneda} (T.
          Cambio 1 {producto.moneda.codigoMoneda} = ${" "}
          {producto.moneda.cotizacion.substr(0, 5)})
        </p>
      )}
      */}
      {totalPaqueteConPlanFamily > 0 && (
        <p style={{ color: "#ffae00", fontWeight: "bold" }}>
          APLICA DESCUENTO POR PLAN FAMILY
        </p>
      )}
    </div>
  );
};

export default TituloSection;



// WEBPACK FOOTER //
// ./src/components/ProcesoCompra/FichaReserva/tituloSection.js